export const AuthUrls = {
  loginWithPhoneNumber: 'user/login/phone_number',
  phoneNumberVerified: 'user/login/phone_number/verified',
  resendVerificationCode: '/user/login/phone_number/resend',
};
